// no itx for this file
const excludedNameParts = /adress|address|kurz|short|anzahl|count/i;

export function hasExcludedSceneName(...names: unknown[]): boolean {
  return names.some((name) => typeof name === "string" && excludedNameParts.test(name));
}
